import {
    GET_LEAVE_REQUESTS,
    GET_LEAVE_DETAILS,
    DELETE_LEAVE_REQUEST,
    CANCEL_LEAVE_REQUEST,
    COMPLETE_LEAVE_REQUEST,
    DELETE_FILE_LEAVE_REQUEST,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    GET_PENDING_LEAVE_REQUESTS,
    DELETE_ROW_LEAVE_REQUEST,
    RESET_PENDING_LEAVE_REQUESTS,
    RESET_LEAVE_DETAILS,
    UPDATE_LEAVE_REQUEST_STATUS,
    RESET_LEAVE_REQUESTS,
    GET_APPROVED_LEAVE_REQUESTS,
    RESET_APPROVED_LEAVE_REQUESTS,
    GET_LEAVE_LOGS_REQUESTS,
    RESET_LEAVE_LOGS_REQUESTS,
} from "shared/constants/ActionTypes";
import { EXPENSE_TYPE } from "shared/constants/AppConst";
const initialState = {
    myLeaveRequests: [],
    pendingLeaveRequests: [],
    approvedLeaveRequests: [],
    myLeaveLogsRequests: [],
    leaveRequestDetails: null,
};

const removeRowLeaveRequest = (previousData, payload) => {
    let leaveRequestDetailsData = { ...previousData };
    if (leaveRequestDetailsData.trxNo === payload.requestId) {
        if (payload.type === EXPENSE_TYPE.TRAVEL) {
            leaveRequestDetailsData.travelReq.trvlDtlList =
                leaveRequestDetailsData.travelReq.trvlDtlList.filter((el) => {
                    return el.id !== payload.rowId;
                });
        }
        if (payload.type === EXPENSE_TYPE.FOOD) {
            leaveRequestDetailsData.travelReq.trvlFoodList =
                leaveRequestDetailsData.travelReq.trvlFoodList.filter((el) => {
                    return el.id !== payload.rowId;
                });
        }
        if (payload.type === EXPENSE_TYPE.HOTEL) {
            leaveRequestDetailsData.travelReq.trvlHotelList =
                leaveRequestDetailsData.travelReq.trvlHotelList.filter((el) => {
                    return el.id !== payload.rowId;
                });
        }
        if (payload.type === EXPENSE_TYPE.OTHER) {
            leaveRequestDetailsData.travelReq.trvlOthBillList =
                leaveRequestDetailsData.travelReq.trvlOthBillList.filter(
                    (el) => {
                        return el.id !== payload.rowId;
                    }
                );
        }
    }
    return leaveRequestDetailsData;
};
const removeFileLeaveRequest = (previousData, payload) => {
    let leaveRequestDetailsData = { ...previousData };
    if (leaveRequestDetailsData.trxNo === payload.requestId) {
        if (payload.type === "LEAVE") {
            leaveRequestDetailsData.empLeaveAttachedFile =
                leaveRequestDetailsData.empLeaveAttachedFile.filter(
                    (file) => file.id !== payload.fileId
                );
        }
        if (payload.type === EXPENSE_TYPE.TRAVEL) {
            leaveRequestDetailsData.travelReq.trvlDtlList =
                leaveRequestDetailsData.travelReq.trvlDtlList.map((item) => {
                    if (item.id === payload.rowId) {
                        return {
                            ...item,
                            trvlDtlAttFile: item.trvlDtlAttFile.filter(
                                (file) => file.id !== payload.fileId
                            ),
                        };
                    }
                    return item;
                });
        }
        if (payload.type === EXPENSE_TYPE.FOOD) {
            leaveRequestDetailsData.travelReq.trvlFoodList =
                leaveRequestDetailsData.travelReq.trvlFoodList.map((item) => {
                    if (item.id === payload.rowId) {
                        return {
                            ...item,
                            trvlFoodDtlAttFile: item.trvlFoodDtlAttFile.filter(
                                (file) => file.id !== payload.fileId
                            ),
                        };
                    }
                    return item;
                });
        }
        if (payload.type === EXPENSE_TYPE.HOTEL) {
            leaveRequestDetailsData.travelReq.trvlHotelList =
                leaveRequestDetailsData.travelReq.trvlHotelList.map((item) => {
                    if (item.id === payload.rowId) {
                        return {
                            ...item,
                            trvlHotelDtlAttFile:
                                item.trvlHotelDtlAttFile.filter(
                                    (file) => file.id !== payload.fileId
                                ),
                        };
                    }
                    return item;
                });
        }
        if (payload.type === EXPENSE_TYPE.OTHER) {
            leaveRequestDetailsData.travelReq.trvlOthBillList =
                leaveRequestDetailsData.travelReq.trvlOthBillList.map(
                    (item) => {
                        if (item.id === payload.rowId) {
                            return {
                                ...item,
                                trvlOthDtlAttFile:
                                    item.trvlOthDtlAttFile.filter(
                                        (file) => file.id !== payload.fileId
                                    ),
                            };
                        }
                        return item;
                    }
                );
        }
    }
    return leaveRequestDetailsData;
};
const updateLeaveRequestStatus = (previousData, payload) => {
    let leaveRequestDetailsData = { ...previousData };
    if (leaveRequestDetailsData.trxNo === payload.trxNo) {
        leaveRequestDetailsData.statusCode = payload.statusCode;
        leaveRequestDetailsData.activityLog = payload.activityLog;
        leaveRequestDetailsData.pendingWith = payload.pendingWith;
    }
    return leaveRequestDetailsData;
};
const cancelLeaveRequestStatus = (previousData, payload) => {
    let leaveRequestDetailsData = { ...previousData };
    if (leaveRequestDetailsData.trxNo === payload.trxNo) {
        leaveRequestDetailsData.statusCode = payload.statusCode;
        leaveRequestDetailsData.activityLog = payload.activityLog;
        leaveRequestDetailsData.pendingWith = payload.pendingWith;
    }
    return leaveRequestDetailsData;
};
const completeLeaveRequestStatus = (previousData, payload) => {
    let leaveRequestDetailsData = { ...previousData };
    if (leaveRequestDetailsData.trxNo === payload.trxNo) {
        leaveRequestDetailsData.statusCode = payload.statusCode;
        leaveRequestDetailsData.activityLog = payload.activityLog;
        leaveRequestDetailsData.pendingWith = payload.pendingWith;
    }
    return leaveRequestDetailsData;
};

export const leaveReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_START:
            return { ...state, loading: true };
        case FETCH_SUCCESS:
            return { ...state, loading: false };
        case FETCH_ERROR:
            return { ...state, error: payload, loading: false };
        case GET_LEAVE_REQUESTS:
            return {
                ...state,
                myLeaveRequests: payload,
            };
        case RESET_LEAVE_REQUESTS:
            return {
                ...state,
                myLeaveRequests: [],
            };
        case GET_PENDING_LEAVE_REQUESTS:
            return {
                ...state,
                pendingLeaveRequests: payload,
            };
        case RESET_PENDING_LEAVE_REQUESTS:
            return {
                ...state,
                pendingLeaveRequests: [],
            };
        case GET_APPROVED_LEAVE_REQUESTS:
            return {
                ...state,
                approvedLeaveRequests: payload,
            };
        case RESET_APPROVED_LEAVE_REQUESTS:
            return {
                ...state,
                approvedLeaveRequests: [],
            };
        case GET_LEAVE_LOGS_REQUESTS:
            return {
                ...state,
                myLeaveLogsRequests: payload,
            };
        case RESET_LEAVE_LOGS_REQUESTS:
            return {
                ...state,
                myLeaveLogsRequests: [],
            };
        case GET_LEAVE_DETAILS:
            return {
                ...state,
                leaveRequestDetails: payload,
            };
        case RESET_LEAVE_DETAILS:
            return {
                ...state,
                leaveRequestDetails: null,
            };
        case DELETE_LEAVE_REQUEST:
            return {
                ...state,
                myLeaveRequests:
                    state.myLeaveRequests.length > 0 &&
                    state.myLeaveRequests.filter(
                        (el) => el.trxNo !== payload.requestId
                    ),
                // leaveRequestDetails: state.leaveRequestDetails !== null && state.leaveRequestDetails?.trxNo === payload.requestId ? null : state.leaveRequestDetails,
                leaveRequestDetails: null,
            };
        case DELETE_FILE_LEAVE_REQUEST:
            return {
                ...state,
                leaveRequestDetails: removeFileLeaveRequest(
                    state.leaveRequestDetails,
                    payload
                ),
            };
        case DELETE_ROW_LEAVE_REQUEST: {
            return {
                ...state,
                leaveRequestDetails: removeRowLeaveRequest(
                    state.leaveRequestDetails,
                    payload
                ),
            };
        }
        case UPDATE_LEAVE_REQUEST_STATUS: {
            return {
                ...state,
                pendingLeaveRequests:
                    state.pendingLeaveRequests.length > 0 &&
                    state.pendingLeaveRequests.filter(
                        (el) => el.trxNo !== payload.trxNo
                    ),
                leaveRequestDetails: updateLeaveRequestStatus(
                    state.leaveRequestDetails,
                    payload
                ),
            };
        }
        case CANCEL_LEAVE_REQUEST: {
            return {
                ...state,
                myLeaveRequests:
                    state.myLeaveRequests.length > 0 &&
                    state.myLeaveRequests.map((item) => {
                        if (item.trxNo === payload.trxNo) {
                            return {
                                ...item,
                                statusCode: payload.statusCode,
                            };
                        } else {
                            return item;
                        }
                    }),
                leaveRequestDetails: cancelLeaveRequestStatus(
                    state.leaveRequestDetails,
                    payload
                ),
            };
        }
        case COMPLETE_LEAVE_REQUEST: {
            return {
                ...state,
                myLeaveRequests:
                    state.myLeaveRequests.length > 0 &&
                    state.myLeaveRequests.map((item) => {
                        if (item.trxNo === payload.trxNo) {
                            return {
                                ...item,
                                statusCode: payload.statusCode,
                            };
                        } else {
                            return item;
                        }
                    }),
                leaveRequestDetails: completeLeaveRequestStatus(
                    state.leaveRequestDetails,
                    payload
                ),
            };
        }

        default:
            return state;
    }
};
